module.exports = __webpack_public_path__ + "img/TNG.96adebd.svg";